import React from 'react';
import './CallButtonStage.css';


const PHONE_ICON = (
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 98 98" fill="none">
  <circle cx="49.4482" cy="49.4473" r="32.8288" fill="white" stroke="white" stroke-width="7.75774"/>
  <circle cx="49.4445" cy="49.4462" r="33.0429" fill="#737373" stroke="white"/>
  <path d="M61.9819 71.2175C63.8842 71.203 65.608 70.8066 66.812 70.0525L67.0454 69.8972C69.862 67.9021 70.93 66.416 71.1001 64.6169L71.1216 64.2527C71.1211 63.8104 71.0925 63.495 70.9956 63.2146C70.9005 62.9396 70.7288 62.6684 70.3931 62.3435C69.8714 61.8388 69.0026 61.2463 67.5396 60.3503L65.8687 59.3445C62.8804 57.5642 61.1201 56.6559 59.7749 56.3943C59.1198 56.2669 58.5697 56.2955 58.0239 56.4558C57.4694 56.6188 56.9016 56.9227 56.2173 57.3738H56.2163C55.437 57.8984 54.7487 58.2929 54.0659 58.4753C53.3624 58.6633 52.6847 58.6213 51.9419 58.3181C51.2154 58.0215 50.4319 57.4769 49.4956 56.6765C48.7911 56.0743 47.9862 55.3158 47.0405 54.3865L46.0464 53.4001C44.6539 52.0077 43.5729 50.8901 42.77 49.9509C41.9696 49.0146 41.425 48.2312 41.1284 47.5046C40.8252 46.7618 40.7832 46.0842 40.9712 45.3806C41.1536 44.6979 41.5482 44.0095 42.0728 43.2302V43.2292C42.5244 42.5441 42.8289 41.98 42.9917 41.4304C43.1517 40.8903 43.1795 40.3468 43.0522 39.696C42.8233 38.5251 42.0988 37.0313 40.728 34.6521L40.1011 33.5769V33.5759C38.602 31.0243 37.8056 29.7148 37.1489 29.0281C36.8346 28.6994 36.5704 28.5347 36.2925 28.4441C36.0027 28.3497 35.6674 28.325 35.1821 28.325C34.487 28.325 33.9044 28.4669 33.269 28.8279C32.6198 29.1968 31.9066 29.7997 30.9634 30.7429H30.9624C29.9243 31.8128 29.3492 32.5156 28.9917 33.2888C28.6789 33.9654 28.5218 34.7207 28.4028 35.8699L28.354 36.3875C28.2927 37.3135 28.3075 38.4148 28.3853 39.4333C28.4635 40.4578 28.6025 41.369 28.7778 41.9275C29.4557 43.961 30.8973 46.4668 32.8452 49.1619C34.7895 51.8518 37.2239 54.7096 39.8677 57.4441C45.1628 62.9208 51.2593 67.8624 55.9077 69.9851C57.7843 70.8157 59.9605 71.233 61.9819 71.2175Z" fill="white" stroke="white" stroke-width="0.775774"/>
</svg>
);



export default function CallButtonStage({ onClick }) {
  return (
    <div className="call-button-stage-wrapper">
      <button
        className="call-button-stage"
        onClick={() => {
          const element = document.getElementById('contacts');
          if (element) {
            const offset = -100; // Поднять на 100px выше
            const y = element.getBoundingClientRect().top + window.pageYOffset + offset;
            
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        }}
        type="button"
      >

        <span className="call-button-stage-icon">
          <div className="pulse-circle-stage" />
          <div className="pulse-circle-stage circle-2-stage" />
          {PHONE_ICON}
        </span>
        <span className="call-button-stage-text"             
          >Связаться</span>
      </button>
    </div>
  );
}
